import React from 'react'
import styles from './Player.module.css'
import clsx from 'clsx'
import { Player as PlayerModel } from '../../models'

export interface PlayerProps extends PlayerModel {}

export default function Player(props: PlayerProps) {
    return (
        <div className={clsx(styles.player, {
            [styles.isTurn]: props.isTurn
        })}>
            <span className={styles.name}>
                {props.name}
            </span>
            <span className={styles.score}>
                {props.score} pt{props.score > 1 && 's'}.
            </span>
        </div>
    )
}